import { useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import logo from '../../assets/justservicelogo.png';
import './Auth.css';

export default function OTPVerify() {
  const navigate = useNavigate();
  const location = useLocation();
  const { verifyOTP, sendOTP } = useAuth();

  const phone = location.state?.phone || '';
  const name = location.state?.name || '';
  const referralCode = location.state?.referralCode || '';

  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const inputs = useRef([]);

  const handleChange = (val, idx) => {
    if (!/^\d?$/.test(val)) return;
    const newOtp = [...otp];
    newOtp[idx] = val;
    setOtp(newOtp);
    if (val && idx < 5) inputs.current[idx + 1]?.focus();
  };

  const handleKeyDown = (e, idx) => {
    if (e.key === 'Backspace' && !otp[idx] && idx > 0) inputs.current[idx - 1]?.focus();
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    const code = otp.join('');
    if (code.length !== 6) { setError('Enter complete 6-digit OTP'); return; }
    setLoading(true); setError('');
    try {
      const res = await verifyOTP(phone, code, name, referralCode);
      const isNewUser = res.data?.isNewUser;
      navigate(isNewUser ? '/create-profile' : '/');
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid OTP. Try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setResending(true); setError(''); setSuccessMsg('');
    try {
      await sendOTP(phone);
      setSuccessMsg('OTP resent successfully!');
      setOtp(['', '', '', '', '', '']);
      inputs.current[0]?.focus();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to resend OTP.');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <img src={logo} alt="JustService24" className="auth-logo-img" />
        </div>
        <h1>Verify OTP</h1>
        <p className="auth-sub">
          Enter the 6-digit code sent to{' '}
          <strong>{phone ? `+91 ${phone}` : ''}</strong>
        </p>

        <form onSubmit={handleVerify} className="auth-form">
          <div className="otp-boxes">
            {otp.map((digit, i) => (
              <input
                key={i}
                ref={el => inputs.current[i] = el}
                type="tel"
                maxLength={1}
                value={digit}
                onChange={e => handleChange(e.target.value, i)}
                onKeyDown={e => handleKeyDown(e, i)}
                className="otp-box"
              />
            ))}
          </div>

          {error && <p className="auth-error">{error}</p>}
          {successMsg && <p style={{ color: 'green', fontSize: '13px', textAlign: 'center' }}>{successMsg}</p>}

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? <><span className="spinner" /> Processing...</> : 'Verify OTP ✓'}
          </button>
        </form>

        <button className="resend-btn" onClick={handleResend} disabled={resending}>
          {resending ? 'Resending...' : 'Resend OTP'}
        </button>

        <button className="resend-btn" onClick={() => navigate(-1)}>
          ← Change Number
        </button>

        <p className="auth-terms">
          By continuing, you agree to our{' '}
          <a href="#">Privacy Policy</a> and <a href="#">Terms & Conditions</a>
        </p>
      </div>
    </div>
  );
}
